if (!customElements.get('product-customization-modal')) {
  customElements.define(
    'product-customization-modal',
    class ProductCustomizationModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        super.hide();
      }

      async show(opener) {
        super.show(opener);


        const container = document.getElementById('customize-plugin-app');
        const imageContainer = document.getElementById('customize-plugin-app-imagen-renderizada');
        const formContainer = document.getElementById('customize-plugin-app-controls');
        const fullContainer = document.getElementById('customize-plugin-app-full-container');

        imageContainer.innerHTML = '';
        formContainer.innerHTML = '';
        fullContainer.innerHTML = '';

        const attributes = container.dataset;

        const coordenadasImagen = {
          x: parseFloat(attributes.productImagenCoordenadasX),
          y: parseFloat(attributes.productImagenCoordenadasY),
        };

        const areaImagen = {
          ancho: parseFloat(attributes.productImagenAreaAncho),
          alto: parseFloat(attributes.productImagenAreaAlto),
        };

        const tamanyoImagen = {
          ancho: parseFloat(attributes.productImagenArchivoAncho),
          alto: parseFloat(attributes.productImagenArchivoAlto),
        };

        const imagen = {
          url: attributes.productImagenUrl,
          coordenadas: coordenadasImagen,
          area: areaImagen,
          tamanyo: tamanyoImagen,
        };

        const coordenadasPlantilla = {
          x: parseFloat(attributes.productPlantillaCoordenadasX),
          y: parseFloat(attributes.productPlantillaCoordenadasY),
        };

        const areaPlantilla = {
          ancho: parseFloat(attributes.productPlantillaAreaAncho),
          alto: parseFloat(attributes.productPlantillaAreaAlto),
        };

        const plantilla = {
          url: attributes.productPlantillaUrl,
          coordenadas: coordenadasPlantilla,
          area: areaPlantilla,
        };

        const posicionamientoImagen = JSON.parse(attributes.productPosicionamientoImagen);
        const posicionamientoTextoHorizontal = JSON.parse(attributes.productPosicionamientoTextoHorizontal);
        const posicionamientoTextoVertical = JSON.parse(attributes.productPosicionamientoTextoVertical);

        const producto = {
          id: parseInt(attributes.productId),
          nombre: attributes.productNombre,
          producto_personalizacion_id: parseInt(attributes.productPersonalizacionId),
          producto_personalizacion_id_imagen_y_texto: parseInt(attributes.productPersonalizacionIdImagenYTexto),
          imagen: imagen,
          orientacion: attributes.productOrientacion,
          plantilla: plantilla,
          posicionamiento_imagen: posicionamientoImagen,
          posicionamiento_texto_horizontal: posicionamientoTextoHorizontal,
          posicionamiento_texto_vertical: posicionamientoTextoVertical,
          precio: parseInt(attributes.productPrecio),
          precio_personalizacion: parseInt(attributes.productPersonalizacionPrecio),
          precio_personalizacion_imagen_y_texto: parseInt(attributes.productPersonalizacionImagenYTextoPrecio),
        };

        const userPreferences = {
          locale: attributes.shopLocale,
        };


        const SubirPlantillaPdf = new RunbottCustomizePlugin.HttpSubirPlantillaPdf();
        const SubirImagenPersonalizacion = new RunbottCustomizePlugin.HttpSubirImagenPersonalizacion();
        const getUrlFuente = new RunbottCustomizePlugin.RemoteGetUrlFuente('https://cdn.runbott.com/assets/fonts/');
        const anyadirAlCarro = new RunbottCustomizePlugin.ShopifyAnyadirAlCarro(
            document.querySelector('cart-drawer'),
            'https://api.runbott.com/customization-files/b2c',
        );
        const getSubidaFicherosPresignedUrl = new RunbottCustomizePlugin.HttpGetSubidaFicherosPresignedUrl(
            'https://api.runbott.com/customization-files/b2c/generate-presigned-url'
        );
        const getDisenyosPredefinidosRepository = new RunbottCustomizePlugin.HttpGetDisenyosPredefinidos(
            'https://cdn.runbott.com/assets/disenyos-predefinidos.json',
        );

        const htmlEngine = new RunbottCustomizePlugin.HtmlEngine(
            producto,
            await getDisenyosPredefinidosRepository.execute(),
            userPreferences,
            fullContainer,
            imageContainer,
            formContainer,
        );

        const appInjector = RunbottCustomizePlugin.createInjector()
            .provideValue('SubirPlantillaPdf', SubirPlantillaPdf)
            .provideValue('SubirImagenPersonalizacion', SubirImagenPersonalizacion)
            .provideValue('GetUrlFuente', getUrlFuente)
            .provideValue('AnyadirAlCarro', anyadirAlCarro)
            .provideValue('GetSubidaFicherosPresignedUrl', getSubidaFicherosPresignedUrl)
            .provideValue('HtmlEngine', htmlEngine)
            .provideClass('PdfEngine', RunbottCustomizePlugin.PdfEngine)
        ;

        const app = appInjector.injectClass(RunbottCustomizePlugin.RunbottCustomizationApp);

        const onCustomizationAccepted = (event) => {
          event.stopImmediatePropagation();
          app.onCustomizationAccepted(
              event.detail.producto,
              event.detail.userPreferences,
              event.detail.cantidad,
              event.detail.imagen_builder,
              event.detail.texto_builder,
              event.detail.imagen_y_texto_builder,
          )
        };

        const onCustomizationDownloadFiles = (event) => {
          event.stopImmediatePropagation();
          app.onDownloadFilesRequested(
            event.detail.producto,
            event.detail.userPreferences,
            event.detail.builder,
          );
        }

        document.addEventListener('runbott:customization:download-files', onCustomizationDownloadFiles);

        document.addEventListener('runbott:customization:accepted', onCustomizationAccepted, { once: true });

        document.addEventListener('runbott:customization:finished',
            (event) => {
            this.hide();
          },
            { once: true },
        );

        app.init();
      }
    }
  );
}
